import React, { useState } from 'react';
import { ListTree, History, Activity, Radio } from 'lucide-react';
import LogViewerComponentForApplicationLogs from '../Components/LogViewerComponentForApplicationLogs';
import LogViewerComponentForGlobalAuditLogs from '../Components/LogViewerComponentForGlobalAuditLogs';
import LogViewerComponentForEventLogs from '../Components/LogViewerComponentForEventLogs';
import AdminHeaderComponent from '../Components/AdminHeaderComponent';

// Mock component for Application Logs
const ApplicationLogsPlaceholder = () => (
  <div className="flex-1 flex flex-col items-center justify-center text-slate-500 bg-[#0f172a]">
    <Activity size={48} className="mb-4 opacity-20" />
    <p className="text-lg font-medium">Standard Output (STDOUT) Stream</p>
    <p className="text-sm">Application runtime logs will appear here.</p>
  </div>
);

function LogViewerPage() {
  const [activeTab, setActiveTab] = useState<'application' | 'audit' | 'events'>('events');

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-[#0f172a]">
      {/* 1. Global Admin Header */}
      {/* <AdminHeaderComponent/> */}

      <div className="flex-none">
        {/* <AdminHeaderComponent /> */}
        <div className="bg-[#1e293b] border-b border-slate-800 px-6 py-3 flex justify-between items-center text-white">
          <h1 className="text-xl font-bold tracking-tight">System Observability</h1>
        </div>
      </div>

      {/* 2. Sub-Header / Tab Navigation */}
      <div className="bg-[#1e293b] border-b border-slate-800 px-6 flex items-center gap-5 sm:gap-8 overflow-x-auto">
        <button
          onClick={() => setActiveTab('events')}
          className={`flex items-center gap-2 py-4 text-sm font-semibold transition-all border-b-2 shrink-0 whitespace-nowrap ${
            activeTab === 'events' 
            ? 'border-emerald-500 text-emerald-400' 
            : 'border-transparent text-slate-400 hover:text-slate-200'
          }`}
        >
          <Radio size={18} />
          Live Events
        </button>

        <button
          onClick={() => setActiveTab('application')}
          className={`flex items-center gap-2 py-4 text-sm font-semibold transition-all border-b-2 shrink-0 whitespace-nowrap ${
            activeTab === 'application' 
            ? 'border-blue-500 text-blue-400' 
            : 'border-transparent text-slate-400 hover:text-slate-200'
          }`}
        >
          <ListTree size={18} />
          Application Logs
        </button>
        
        <button
          onClick={() => setActiveTab('audit')}
          className={`flex items-center gap-2 py-4 text-sm font-semibold transition-all border-b-2 shrink-0 whitespace-nowrap ${
            activeTab === 'audit' 
            ? 'border-blue-500 text-blue-400' 
            : 'border-transparent text-slate-400 hover:text-slate-200'
          }`}
        >
          <History size={18} />
          Audit Logs
        </button>
      </div>

      {/* 3. Main Content Area */}
      <div className="flex-1 overflow-hidden flex flex-col">
        {activeTab === 'events' ? (
          <LogViewerComponentForEventLogs />
        ) : activeTab === 'application' ? (
          <LogViewerComponentForApplicationLogs />
        ) : (
          <LogViewerComponentForGlobalAuditLogs /> 
        )}
      </div>

      {/* 4. Global System Status Footer (Optional) */}
      <div className="bg-[#0f172a] border-t border-slate-800 px-4 py-1 flex justify-end items-center gap-4 text-[10px] text-slate-500 uppercase tracking-tighter">
        <span className="flex items-center gap-1">
          <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></span>
          Gateway: Connected
        </span>
        <span>Environment: Production</span>
      </div>
    </div>
  );
}

export default LogViewerPage;